import React from 'react';
import './index.scss';
import LogoS from '../../../assets/images/logo-s.png';
// import { useRef } from 'react';
// import { useEffect } from 'react';
// import { gsap } from 'gsap-trial/all';
// import DrawSVGPlugin from 'gsap-trial/DrawSVGPlugin';

const Logo = () => {

    return (
        <div className='logo-container' >
            <img className='solid-logo' src={LogoS} alt="E" />

        </div>
    )
}

export default Logo